import React from 'react';
import { Toaster as ReactToaster } from 'react-hot-toast';

const Toaster = () => {
  return (
    <div data-testid="atom-toaster">
      <ReactToaster
        toastOptions={{
          ariaProps: { role: 'status', 'aria-live': 'polite' },
        }}
      />
    </div>
  );
};

export default Toaster;
